<template>
  <div class="main-container information" v-loading="loading">
    <ul class="news-list" v-infinite-scroll="newsLoad">
      <li class="news-item" @click="newDetail(item)" v-for="(item, index) in news" :key="item.id">
        <span class="seq">{{ index + 1 }}</span>
        <p class="news-title">{{ item.essayTitle }}</p>
      </li>
      <el-backtop target=".news-list" :right="20" :bottom="40"></el-backtop>
    </ul>
  </div>
</template>

<script>
  import {
    queryNewsList
  } from "@/api/policy/policy";
  export default {
    name: "Policy",
    data() {
      return {
        loading: false,
        news: [],
        pagerConfig: {
          currentPage: 1,
          pageSize: 10
        }
      }
    },
    methods: {
      getData(){
        this.loading = true
        queryNewsList('new', this.pagerConfig)
        .then(res => {
          this.loading = false
          this.news = [...this.news, ...res.data.data.records]
          this.pagerConfig.currentPage++
        })
        .catch(error => {
          this.loading = false
        })
      },
      newsLoad(){
        this.getData();
      },
      newDetail(news){
        const essayUrl = news.essayUrl;
        window.open(essayUrl, '_blank');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .information {
  
  }
  .news-list {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
  .news-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border-bottom: 1px solid #ebebeb;
    cursor: pointer;
    padding: 10px 0;
    line-height: 1.5;
    .seq {
      min-width: 28px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border: 1px solid #999;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      margin-right: 10px;
    }
    .news-title {
      flex: 1;
    }
    &:hover {
      color: #C73122;
      .seq {
        border-color: #C73122;
      }
    }
  }
</style>
